import { cepUrl } from '../api-urls';
import axios from 'axios';
import { path } from 'ramda';

const removeMask = zipCode => zipCode.replace(/\D+/g, '');

function requestGetAddressByZipCode(zipCode) {
  return {
    url: `${cepUrl}/${removeMask(zipCode)}`,
    method: 'get'
  };
}

const addressContainsBlankBlockedFields = ({ address, neighborhood }) =>
  address === null || neighborhood == null;

export const getAddressByZipCode = async zipCode => {
  try {
    const response = await axios(requestGetAddressByZipCode(zipCode));
    const data = path(['data'], response);

    return {
      addressInfo: { ...data },
      openAddressToEdit: addressContainsBlankBlockedFields(data),
      errors: { zipCode: '' }
    };
  } catch (err) {
    console.error(err);
    return {
      errors: {
        zipCode:
          'Não encontramos o CEP desejado. Por favor verifique os dados informados e tente novamente.'
      }
    };
  }
};
